import * as types from './mutation-types';

export const mutations = {
  [types.LIST_BANNERS] (state, payload) {
    state.banners = payload
  },

  [types.SET_BANNER] (state, payload) {
    state.currentBanner = payload;
  },
  [types.SET_BANNER_SET] (state, payload) {
    state.currentBannerSet = payload;
  },
  [types.SET_BANNER_SET_EDIT] (state, payload) {
    state.currentBannerSetEdit = payload;
  },

  [types.SET_RESULT_COUNT](state, number) {
    state.filters.size = number;
    state.pagination.per_page = number;
    state.pagination.total = number;
    state.pagination.to = number;
  },

  [types.SET_FILTER_TOTAL](state, total) {
    state.pagination.total = total;
    state.pagination.last_page = Math.ceil(total / state.pagination.per_page);
  },

  [types.SET_CURRENT_PAGE](state, page) {
    state.pagination.current_page = page;
  },
  [types.SET_SEARCH_QUERY](state, term) {
    state.filters.searchQuery = term;
  },
  [types.SET_PREVIEW](state, payload) {
    state.preview = payload
  }
}